import styled from 'styled-components'
import { accessibilityColors } from '@edulastic/colors'

const { text, bg } = accessibilityColors.labels.yellow

// ASM-985 Figma (Test Review, "Telling user about active editing on test"): a full-width
// bar under the header that pushes the page down
export const BannerBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 24px 0;
  padding: 8px 24px;
  min-height: 38px;
  background: ${bg};
  border: 1px solid ${text};
  border-radius: 4px;
  color: ${text};
  font-size: 12px;
  font-weight: 600;

  svg {
    flex-shrink: 0;
  }
  svg,
  svg path {
    fill: ${text};
  }
`

export const BannerAction = styled.a`
  color: ${text};
  text-decoration: underline;
  &:hover,
  &:focus {
    color: ${text};
  }
`

export const BannerButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: ${text};
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
`
